<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ pagetop</a>
    <div class="wrap">
      <div class="max grid">
        <div class="grid__item">
          <h3>主催</h3>
          <p>千葉市を美しくする会<br>(共催：千葉市）<br>
          TEL.043-245-5138<br>
          E-MAIL.<a href="mailto:bikai@city.chiba.lg.jp" target="_blank" rel="noopener">bikai@city.chiba.lg.jp</a><br>
          Web.<a href="https://bikai.org" target="_blank" rel="nofollow">https://bikai.org</a><br>
          <small>※混雑時、担当者が対応ができない場合がございますので、可能な限りメールでお問い合わせください。</small></p>
        </div>
        <div class="grid__item">
          <h3>協賛広告に関すること</h3>
          <p>千葉の親子三代夏祭り協賛事務局<br>受託者：JCOMマーケティング株式会社<br>担当窓口：(株)セレスポ千葉支店内<br>
            TEL.043-214-8400<br>
            E-MAIL.<a href="mailto:kyousan-oyako@cerespo.co.jp" target="_blank" rel="noopener">kyousan-oyako@cerespo.co.jp</a><br>
            <small>※混雑時、担当者が対応ができない場合がございますので、可能な限りメールでお問い合わせください。</small></p>
        </div>
      </div>
      <p class="t-center">
        <a href="https://x.com/chiba_bikai" target="_blank" rel="nofollow" class="sns">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1227" fill="none"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"></path></svg>https://x.com/chiba_bikai
        </a>
      </p>
    </div>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: module.tone(module.$red, -4);
  color: module.$white;
  a{
    color: module.$white;
  }
  .pagetop{
    background: module.tone(module.$red, -5);
    display: block;
    text-align: center;
    padding: 1rem 0;
    &:hover{
      background: module.tone(module.$red, -3);
    }
  }
  .wrap{
    padding: 4rem module.side();
  }
  .grid{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3.2rem;
    margin: 0 0 2.4rem;
    @media screen and (max-width: module.$phone){
      grid-template-columns: 1fr;
    }
    &__item{
      h3{
        font-size: 1.32rem;
        border-bottom: rgba(module.$white,.12) 1px solid;
        padding: 0 0 .64rem;
        margin: 0 0 .8rem;
      }
      a{
        text-decoration: underline;
      }
      small{
        font-size: .88rem;
      }
    }
  }
  .sns{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: .64rem;
    border: rgba(module.$white,.12) 1px solid;
    border-radius: 999rem;
    padding: 1rem 1.6rem;
    &:hover{
      border: rgba(module.$white,1) 1px solid;
    }
    svg{
      width: 1.2rem;
    }
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>